import React, { useEffect, useState, useRef } from 'react';
import { useResetRecoilState, useSetRecoilState } from 'recoil';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactDOM from 'react-dom';

import { FlexBox } from '@ecp/common/src/layouts/flex/styled';

import { contentsUtilityState } from '@bo-recoil/common/atom';

const Container = styled(FlexBox)`
  width: 100%;
  height: 60px;
  align-items: center;
  justify-content: flex-end;

  background-color: rgba(248, 248, 248, 0.85);
  box-shadow: 0px -4px 5px rgba(0, 0, 0, 0.05);
  padding: 0 30px;
  z-index: 300;
`;

const ContentsUtility = ({ children, ...props }) => {
  const setContentsUtility = useSetRecoilState(contentsUtilityState);
  const resetContentsUtility = useResetRecoilState(contentsUtilityState);

  const [mounted, setMounted] = useState(false);
  const portalNode = useRef();
  portalNode.current = document.getElementById('contents-utility');

  useEffect(() => {
    setContentsUtility(true);
    setMounted(true);

    return () => resetContentsUtility();
  }, [setMounted, setContentsUtility, resetContentsUtility]);

  return mounted ? ReactDOM.createPortal(<Container {...props}>{children}</Container>, portalNode.current) : <></>;
};

ContentsUtility.propTypes = {
  children: PropTypes.node,
};

export default ContentsUtility;
